// components/tickets/TicketsSummary.tsx
import React from "react";
import { Ticket } from "../../lib/api/ticket";

interface TicketsSummaryProps {
  tickets: Ticket[];
}

const TicketsSummary: React.FC<TicketsSummaryProps> = ({ tickets }) => {
  // Total tickets
  const totalTickets = tickets.length;

  // Total revenue (sum of order amountTotal)
  const totalRevenue = tickets.reduce((sum, t) => {
    const total = parseFloat(
      String((t.orderId?.amountTotal as any) / t.orderId?.quantity) || "0"
    );
    return sum + total;
  }, 0);

  // Unique orders
  //   const uniqueOrders = new Set(tickets.map((t) => t.orderId?.id)).size;

  return (
    <div className="bg-[#F5F3F0] border rounded-lg p-4 mb-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-3">
        Tickets Summary
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
        <div className="p-3 bg-white rounded-md shadow text-center">
          <p className="text-2xl font-bold text-blue-600">{totalTickets}</p>
          <p className="text-gray-600 text-sm">Total Tickets</p>
        </div>
        <div className="p-3 bg-white rounded-md shadow text-center">
          <p className="text-2xl font-bold text-green-600">
            £{(totalRevenue / 100).toLocaleString()}.00
          </p>
          <p className="text-gray-600 text-sm">Total Revenue</p>
        </div>
        {/* <div className="p-3 bg-white rounded-md shadow text-center">
          <p className="text-2xl font-bold text-purple-600">{uniqueOrders}</p>
          <p className="text-gray-600 text-sm">Unique Orders</p>
        </div> */}
      </div>
    </div>
  );
};

export default TicketsSummary;
